module.exports = __webpack_public_path__ + "fonts/fa-brands-400.f4120760.woff2";